import React from "react";

// Style classes for full page spinner
const spinnerClasses = `
  w-screen h-screen fixed top-0 left-0 z-[1000000000]
  bg-[rgba(255,255,255,0.21)] flex items-center justify-center text-center
  [&.glass]:shadow-[inset_0_0_2000px_rgba(255,255,255,0.5)] [&.glass]:backdrop-blur-[3px]
  [&_.ant-spin_.ant-spin-dot-item]:!bg-[var(--primary)]
`;

interface Props {
  className?: string;
  children?: React.ReactNode;
}

export default function FullPageSpinnerStyler(props: Props) {
  return <div className={`${spinnerClasses} ${props.className ?? ""}`}>{props.children}</div>;
}
